import React from 'react';
import VoiceWebsiteBuilder from './VoiceWebsiteBuilder';

export default function AiChartTab(){
  return <VoiceWebsiteBuilder />;
}
